import React from 'react';

const HorizontalSeparator = () => {
  return <div className='horizontal-separator' />;
};
export default HorizontalSeparator;
